import { AbstractQuery } from 'src/models/query';

export class GetTheSharedQueriesForTheUserAsListQuery extends AbstractQuery {
	name = 'IFS_Organization_SharedQueries_Query_Queries_GetTheSharedQueriesForTheUserAsListQuery';
	sort = [];

	constructor() {
		super();
	}
}

export class GetTheOrganizationTreeForTheUserQuery extends AbstractQuery {
	name = 'IFS_Organization_Notebook_Query_Queries_GetTheOrganizationTreeForTheUserQuery';
	sort = [];

	constructor(node = 'tree_notebooks', parentNodeIdentifier = '') {
		super();
		delete this.page;
		this.parameters.push({ node });
		this.parameters.push({ parentNodeIdentifier });
	}
}

export class GetTheSharedQueriesForTheUserQuery extends AbstractQuery {
	name = 'IFS_Organization_SharedQueries_Query_Queries_GetTheSharedQueriesForTheUserQuery';
	sort = [];

	constructor(node = 'tree_sharedQueries', parentNodeIdentifier = '') {
		super();
		delete this.page;
		this.parameters.push({ node });
		this.parameters.push({ parentNodeIdentifier });
	}
}

export class GetTheFavoriteIdosForTheUserQuery extends AbstractQuery {
	name = 'IFS_Organization_IdoLinkDropZone_Query_Queries_GetTheFavoriteIdosForTheUserQuery';
	sort = [];
	constructor() {
		super();
	}
}
